import React, { useCallback, useState } from 'react';
import {
  Scr,
  LogoWrap,
  LogoImg,
  SuccessWrap,
  Portal,
  Rings,
  Spark,
  Tick,
  ContentWrap,
  Sub,
  Divider,
  Actions,
  ActionCard,
  Ico,
  Txt,
  Arrow,
  ShareSection,
  ShareTitle,
  ShareRow,
  ShareBtn,
  Security
} from './SuccessScreen.styles';

export default function SuccessScreen({ onHome, onDesigns }) {

  const currentUrl = window.location.href;
  const [toast, setToast] = useState(false);

  const showToast = useCallback(() => {
    setToast(true);
    setTimeout(() => setToast(false), 2000);
  }, []);

  const handleShare = useCallback(async (type) => {
    if (type === 'copy') {
      try {
        await navigator.clipboard.writeText(currentUrl);
        showToast();
      } catch (e) {}
      return;
    }

    if (type === 'facebook') {
      const encoded   = encodeURIComponent(currentUrl);
      const ua        = navigator.userAgent || '';
      const isIOS     = /iphone|ipad|ipod/i.test(ua);
      const isAndroid = /android/i.test(ua);
      if (isIOS) {
        window.location.href = `fb://share?href=${encoded}`;
        setTimeout(() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encoded}`, '_blank'), 1500);
      } else if (isAndroid) {
        window.location.href = `intent://share#Intent;package=com.facebook.katana;scheme=fb;end`;
        setTimeout(() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encoded}`, '_blank'), 1500);
      } else {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encoded}`, '_blank');
      }
      return;
    }

    if (type === 'messenger') {
      const encoded   = encodeURIComponent(currentUrl);
      const ua        = navigator.userAgent || '';
      const isIOS     = /iphone|ipad|ipod/i.test(ua);
      const isAndroid = /android/i.test(ua);
      if (isIOS) {
        window.location.href = `fb-messenger://share?link=${encoded}`;
        setTimeout(() => window.open(`https://www.facebook.com/dialog/send?link=${encoded}&app_id=302192783996643&redirect_uri=${encoded}`, '_blank'), 1500);
      } else if (isAndroid) {
        window.location.href = `intent://share#Intent;package=com.facebook.orca;scheme=fb-messenger;end`;
        setTimeout(() => window.open(`https://www.facebook.com/dialog/send?link=${encoded}&app_id=302192783996643&redirect_uri=${encoded}`, '_blank'), 1500);
      } else {
        window.open(`https://www.facebook.com/dialog/send?link=${encoded}&app_id=302192783996643&redirect_uri=${encoded}`, '_blank');
      }
      return;
    }

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'ARGO Beyond Reality',
          text: 'Trải nghiệm ARGO Beyond Reality',
          url: currentUrl
        });
      } catch (e) {}
    }
    /* eslint-disable-next-line */
  }, [currentUrl]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', background: '#030816', minHeight: '100svh' }}>
      <Scr>
        <LogoWrap>
          <LogoImg src="/logo.png" alt="ARGO Beyond Reality" />
        </LogoWrap>

        <SuccessWrap aria-label="Trải nghiệm hoàn tất">
          <Portal>
            <Rings />
            <Spark className="s1" />
            <Spark className="s2" />
            <Tick />
          </Portal>
        </SuccessWrap>

        <ContentWrap>
          <Sub>
            Cảm ơn bạn đã trải nghiệm<br />
            ARGO Beyond Reality.
          </Sub>
          <Divider />
        </ContentWrap>

        <Actions aria-label="Điều hướng sau trải nghiệm">
          <ActionCard 
            as="button"
            onClick={onHome}
          >
            <Ico>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.2">
              <path d="M3 11.5 12 4l9 7.5" />
              <path d="M5.5 10.5V20h13v-9.5" />
              <path d="M9.5 20v-6h5v6" />
            </svg>
            </Ico>
            <Txt>
              <strong>Trở lại trang chủ</strong>
              <span>Quay về trang chủ ARGO</span>
            </Txt>
            <Arrow />
          </ActionCard>

          <ActionCard 
            className="purple" 
            as="button"
            onClick={onDesigns}
          >
            <Ico>
            <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.2">
              <rect x="4" y="4"   width="6" height="6" rx="1" />
              <rect x="14" y="4"  width="6" height="6" rx="1" />
              <rect x="4" y="14"  width="6" height="6" rx="1" />
              <rect x="14" y="14" width="6" height="6" rx="1" />
            </svg>
            </Ico>
            <Txt>
              <strong>Xem các mẫu thiết kế khác</strong>
              <span>Khám phá thêm mẫu AR ấn tượng</span>
            </Txt>
            <Arrow />
          </ActionCard>
        </Actions>

        <ShareSection>
          <ShareTitle>Chia sẻ trải nghiệm</ShareTitle>
          <ShareRow>
            <ShareBtn onClick={() => handleShare('facebook')} aria-label="Chia sẻ Facebook">f</ShareBtn>
            <ShareBtn onClick={() => handleShare('messenger')} aria-label="Chia sẻ Messenger">●</ShareBtn>
            <ShareBtn onClick={() => handleShare('copy')} aria-label="Sao chép liên kết">
            <svg viewBox="0 0 24 24">
              <path d="M10 13a5 5 0 0 0 7.07 0l2.12-2.12a5 5 0 0 0-7.07-7.07L10.9 5" />
              <path d="M14 11a5 5 0 0 0-7.07 0L4.8 13.12a5 5 0 0 0 7.07 7.07l1.22-1.22" />
            </svg>
            </ShareBtn>
            <ShareBtn onClick={() => handleShare('more')} aria-label="Chia sẻ thêm">···</ShareBtn>
          </ShareRow>
        </ShareSection>

        <Security>
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
            <path d="M12 3 5 6v5c0 5 3 8 7 10 4-2 7-5 7-10V6l-7-3z" />
            <path d="m9 12 2 2 4-5" />
          </svg>
          Bảo mật tuyệt đối <span>|</span> Trải nghiệm tức thì
        </Security>
      </Scr>

      {/* Toast copy */}
      <div style={{
        position: 'fixed',
        bottom: 'max(32px, env(safe-area-inset-bottom) + 16px)',
        left: '50%',
        transform: `translateX(-50%) translateY(${toast ? '0' : '20px'})`,
        opacity: toast ? 1 : 0,
        transition: 'opacity .25s ease, transform .25s ease',
        pointerEvents: 'none',
        zIndex: 999,
        background: 'rgba(0,194,255,.15)',
        backdropFilter: 'blur(14px)',
        border: '0.5px solid rgba(0,194,255,.4)',
        borderRadius: 999,
        padding: '10px 20px',
        display: 'flex', alignItems: 'center', gap: 8,
        color: '#fff', fontSize: 14, fontWeight: 600,
        fontFamily: "'Exo 2', sans-serif",
        whiteSpace: 'nowrap',
        boxShadow: '0 4px 20px rgba(0,194,255,.2)',
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="#00C2FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Đã sao chép liên kết
      </div>
    </div>
  )
};
